let AbstractGeometryOperationResult = require('./abstractOperationResult');

/**
 * Класс IntersectsResult определяет структуру результата при опрерации построения пересечения геометрий
 * @extends AbstractGeometryOperationResult
 */
class IntersectsResult extends AbstractGeometryOperationResult {
  /**
   * Создает экземпляр класса IntersectsResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IntersectsResult";
  }
}

module.exports = IntersectsResult;